//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
// import seo from '@/middleware/seo'

export default {
  name: 'AccountFavoritesExcursionsView',
  components: {
    Empty: () => import('@/components/common/Empty/index'),
    ExcursionCard: () => import('@/components/common/ExcursionCard/index')
  },
  layout: 'personal-area',
  // middleware: [seo],
  data () {
    return {
      loading: false
    }
  },
  head () {
    return {
      title: this.$t('pages.account-favorites-excursions.seo.title'),
      meta: this.$createSEOMeta({
        og: {
          type: 'website',
          image: this.SEOImage || this.$store.getters.host + '/meta-image-default-small.jpg?v=2',
          url: this.SEOUrl || this.$store.getters.host,
          locale: this.SEOLocale || `${this.$i18n.locale}_${this.$i18n.locale.toUpperCase()}`,
          site_name: this.SEOSiteName || this.$t('pages.index.seo.site-name'),
        },
        vk: {
          image: this.SEOImage || this.$store.getters.host + '/meta-image-default-small.jpg?v=2',
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      excursions: 'favorites/excursions',
      city: 'cities/default'
    }),
    url () {
      return this.$store.state.host + this?.$route?.fullPath
    }
  },
  mounted () {
    this.loading = true
    this.$store.dispatch('favorites/fetch', {
      entity: 'excursions',
      params: {
        count: 100500,
        lang: this.$i18n.locale,
        city_id: this.$config.singleCity ? this.city.id : null
      }
    })
      .then(() => this.loading = false)
      .catch(() => this.loading = false)
      .finally(() => this.loading = false)
  },
  methods: {
    avatar (item) {
      return item?.guide?.images[0] || item?.agency?.images[0] || item?.agency?.logo || ''
    }
  }
}
